import { IrsForm4506, IrsForm4506LoanModel, IrsFormsStatus } from '../../form-4506c/form-4506c.models';
import { LoanItemStatus, LoanItemStatusIconType } from '../../shared/models';
import { nonNullish } from '../../shared/utils';
import { ILoanStatusCard, LoanStatusCardConfig, LoanStatusCardType } from './loan-status-card.model';

export const GetForm4506CStatus = (form4506LoanModel: IrsForm4506LoanModel, update: IrsForm4506[] | null): ILoanStatusCard => {
  const cardBase = LoanStatusCardConfig.find((c) => c.cardType === LoanStatusCardType.Form4506C);
  const card = <ILoanStatusCard>{ ...cardBase, cardType: LoanStatusCardType.Form4506C };

  if (nonNullish(update) || form4506LoanModel?.irsFormsStatus === IrsFormsStatus.Incomplete) {
    card.status = LoanItemStatus.Warning;
    card.icon = LoanItemStatusIconType.Diamond;
    card.descriptionHtml = `Incomplete`;
  } else if (form4506LoanModel?.irsFormsStatus === IrsFormsStatus.Complete) {
    card.status = LoanItemStatus.Complete;
    card.icon = LoanItemStatusIconType.Circle;
    card.descriptionHtml = `Complete`;
  }

  return card;
};
